module.exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`
};


//# sourceMappingURL=pt-PT.main.js.map
